import React from 'react';
import CartHelper from "../../../services/Cart/Helper/CartHelper";
import {parseDate} from "../../../services/Common/Date/DateHelper";
import ItemHelper from "../../../services/Menu/services/Item/ItemHelper";
import SummaryItem from "./SummaryItem";
import CartUtils from "../../../services/Cart/CartUtils";
import {useTranslation} from "react-i18next";
import {OrderItemApi} from "../../../services/Api/types";


interface Props {
    orderItems: OrderItemApi[];
    items: Record<string, any>[];
    promotions: Record<string, any>[];
    modifierGroups: Record<string, any>[];
}

const SummaryItemsComponent = ({orderItems, items, promotions, modifierGroups}: Props) => {
    const {t} = useTranslation();
    const tipOrderItems = CartUtils.getTipItemIds(promotions);

    const getSubItemsToRender = (itemModifierGroups: any, modifierGroups: any, items: any, lvl: number) => {
        const itemsToRender: string[] = [];

        [...itemModifierGroups].forEach((itemModifierGroup: any) => {
            [...itemModifierGroup.selected_items].sort((a: any, b: any) => a.name.localeCompare(b.name)).map((selectedItem: any) => {
                itemsToRender.push(`${selectedItem.quantity}x ${CartHelper.getItemName(items, selectedItem.item_id, selectedItem.name)}`);
                const nextSubItems = getSubItemsToRender(selectedItem.modifier_groups, modifierGroups, items, lvl + 1);

                nextSubItems.forEach(subItem => {
                    itemsToRender.push(subItem)
                })
            })
        })

        return itemsToRender;
    }

    const getPromotionItem = (item: OrderItemApi, promotions: Record<string, any>[]) => {
        const valuePromotions = promotions.filter((promotion) => promotion.value_money && promotion.value_money.amount);
        return valuePromotions.find((x) => x.items.some((y: any) => y.order_item_id == item.id));
    }

    const getSortedOrderItems = () => {
        return [...orderItems].sort((a, b) => {
            const dateA = parseDate(a.created_at).getTime();
            const dateB = parseDate(b.created_at).getTime();

            if (dateA !== dateB) {
                return dateA - dateB;
            }

            return a.id - b.id;
        })
    }

    return (
        <div className="card-cart">
            <div className="container-fluid">
                <h3 className="card-cart-header">{t("modules.summary.field.products.title")}</h3>
                <div className={"card-cart-body"}>
                    <div className={"cart-items-body"}>
                        {
                            getSortedOrderItems().map((orderItem: any) => {
                                    if (tipOrderItems.includes(orderItem.uid)) return <></>;

                                    const item = ItemHelper.getItem(items, orderItem.item_id)
                                    const promotionItem = getPromotionItem(orderItem, promotions);

                                    if (!item) return <></>;

                                    return (
                                        <SummaryItem items={items} orderItem={orderItem}
                                                     modifierGroups={modifierGroups} key={orderItem.id}
                                                     promotion={promotionItem}
                                                     item={item}
                                        />
                                    )
                                }
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SummaryItemsComponent;